module.exports = __webpack_public_path__ + "img/img-video.cd00ce30.jpg";